export const pluralizeReviews = (count: number): string => {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return `${count} отзывов`;
    }

    switch (lastDigit) {
        case 1:
            return `${count} отзыв`;
        case 2:
        case 3:
        case 4:
            return `${count} отзыва`;
        default:
            return `${count} отзывов`;
    }
};

export const pluralizeCourses = (count: number): string => {
    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return `${count} курсов`;
    }

    if (lastDigit === 1) {
        return `${count} курс`;
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
        return `${count} курса`;
    }

    return `${count} курсов`;
};